;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="ecad5cdc-87ae-41bd-be7c-5e04a16f6611",e._sentryDebugIdIdentifier="sentry-dbid-ecad5cdc-87ae-41bd-be7c-5e04a16f6611")}catch(e){}}();import React__default, { useContext } from 'react';
import { Anchor } from '@zooplus/ui-components';
import AppContext from '../../context/AppContext.js';
import '../../_virtual/_sentry-release-injection-file.js';
import { LinkTypeEnum } from '../Link/Link.js';
import styles from './CategoryFlyout.module.scss.js';

const TopBrandsFlyout = ({ category, }) => {
    const { title, path, children } = category;
    const { translations } = useContext(AppContext);
    const viewAllLabel = translations.get('shop.header.categories.title.link');
    return (React__default.createElement("div", { className: styles.scrollBox },
        React__default.createElement("div", { className: styles.flyOutHeader },
            React__default.createElement(Anchor, { href: path, "data-link-type": LinkTypeEnum.PRIMARY, "data-zta": "category-flyout-topBrands-level2-link" },
                viewAllLabel,
                " ",
                title)),
        React__default.createElement("ul", { id: "header-category-flyout-topBrands-level3-links", className: styles.topBrandsPanel }, children?.map((item) => (React__default.createElement("li", { key: item.title, className: styles.groupItem },
            React__default.createElement(Anchor, { "data-zta": "category-flyout-topBrands-level3-link", key: item.title, href: item.path, "data-link-type": LinkTypeEnum.NEUTRAL, variant: LinkTypeEnum.NEUTRAL }, item.title)))))));
};

export { TopBrandsFlyout as default };
//# sourceMappingURL=TopBrandsFlyout.js.map
